var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwissFrancs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8402 2H9.20341C8.63796 2 8.17979 2.45817 8.17979 3.02363V15.9414H6.02363C5.45817 15.9414 5 16.3995 5 16.965C5 17.5304 5.45817 17.9886 6.02363 17.9886H8.17979V20.9764C8.17979 21.5418 8.63796 22 9.20341 22C9.76887 22 10.227 21.5418 10.227 20.9764V17.9886H14.0218C14.5873 17.9886 15.0455 17.5304 15.0455 16.965C15.0455 16.3995 14.5873 15.9414 14.0218 15.9414H10.227V12.3632H17.3728C17.9382 12.3632 18.3964 11.905 18.3964 11.3396C18.3964 10.7741 17.9382 10.3159 17.3728 10.3159H10.227V4.04725H18.8402C19.4057 4.04725 19.8639 3.58908 19.8639 3.02363C19.8639 2.45817 19.4057 2 18.8402 2Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwissFrancs);
export default __webpack_public_path__ + "static/media/swiss-francs.88647783ca8f3656bd7523c6c2a036e4.svg";
export { ForwardRef as ReactComponent };